module.exports = __webpack_public_path__ + "images/menu6310834242a54c9519f0cc8ffce46501.svg";